import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import {AuthService} from "@services/auth.service";

export const IsLoggedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isLoggedIn().then((isLoggedIn) => {
    return isLoggedIn ? true : router.createUrlTree(['/403']);
  }).catch(() => {
    return router.createUrlTree(['/403']);
  });
};
